import React, { useState, useEffect } from "react";
import MainImage from "../Components/MainImage";
import im from "../Media/deliveryyyy;;.png";
import {
  Container,
  Stack,
  Typography,
  useMediaQuery,
  Box,
} from "@mui/material";
import SmallBtns from "../Components/SmallBtns";
import OurGoal from "../Components/OurGoal";
import kk from "../Media/deliveryy.png";
import kk2 from "../Media/deliveryyyyyy.png";
import AboutUs from "../Components/AboutUs";
import ServicesCard from "../Components/ServicesCard";
import Questions from "../Components/Questions";
import db from "../DbFile.json";
import cc from "../Media/wallet.png";
import cc3 from "../Media/deliveryyy.png";
import MiniCards from "../Components/MiniCards";
import { useTranslation } from "react-i18next";

export default function Delivary({ setTheState }) {
  const matches = useMediaQuery("(min-width:410px)");
  const [el, setEl] = useState(db.first_array);
  const [Qs, setQs] = useState(db.D_Q);
  const { t } = useTranslation();
  useEffect(() => {
    setTheState(false);
  }, []);
  return (
    <>
      <MainImage
        image={im}
        txt1={"Any Thing To"}
        txt2={"Anyone Delivered"}
        btxt={"Book your ride"}
      />
      <br />
      <br />
      <Container>
        <Stack
          direction={matches ? "row" : "column"}
          gap={4}
          sx={{ justifyContent: "center", alignItems: "center" }}
        >
          <SmallBtns txt={"SUPERMARKET"} name={"GetAnyThing"} />
          <SmallBtns txt={"Delivery"} name={"Delivary"} />
        </Stack>
        <br />
        <br />
        <br />
        <Stack sx={{ justifyContent: "center", alignItems: "center" }}>
          <Typography
            sx={{ color: "#1D2877", fontWeight: "bold", fontSize: "30px" }}
          >
            {t("Delivary Service")}
          </Typography>
          <Typography sx={{ color: "#1D2877", fontSize: "20px" }}>
            {t("we are ready to Meet all your needs in just one click")}
          </Typography>
        </Stack>
        <br />
        <br />

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: "60px",
          }}
        >
          <MiniCards
            imgg={cc}
            txt={"Buy anything."}
            txt2={
              "Our Captains will purchase any item from the store for you and deliver it straight to your door."
            }
          />
          <MiniCards
            imgg={cc3}
            txt={"Send anything."}
            txt2={
              "Our Captains will pick up any package for you or from you and take it where it needs to go."
            }
          />
        </div>
      </Container>

      {/* <OurGoal im={kk} caption={'Instant deliveries.'} btn={'Book your ride'}
        txt={'We’ll pick up a package for you or from you and take it where it needs to go, instantly with a tap.'}/> */}

      <OurGoal
        im={kk}
        caption={"Instant deliveries for your orders where ever you are."}
        btn={"Book your ride"}
        txt={
          "We’ll pick up a package for you or from you and take it where it needs to go, instantly with a tap."
        }
      />
      <AboutUs
        caption={"Track your orders live"}
        txt={
          "Know exactly where your items are with real time updates every step of the way, from pickup to dropoff"
        }
        pic={kk2}
        btn={"Book your ride"}
      />

      <Box
        sx={{
          marginTop: "5%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{ fontWeight: "bold", fontSize: "40px", color: "#1D2877" }}
        >
          {t("Explore more with Mashawiri")}
        </Typography>
        {el && <ServicesCard el={el.filter((el) => el.id !== 3)} />}
      </Box>
      <Questions questions={Qs} />
    </>
  );
}
